import _ from 'underscore';

import { ContentMapper } from '~src/spacesPlatform/models/mappers/ContentMapper';

import { MapperHelper } from '../../../spacesPlatform/models/mappers/MapperHelper';
import { IUserInfo } from '../../../userManagement/users/models/IUserInfo';
import { ISharedVersion } from '../../serverApi/requests/GetShareActivityRequest';
import { IShareAction } from '../../serverApi/requests/GetSharedWithMeRequest';
import { ISharedVersionInfo } from '../ISharedVersionInfo';
import { ISharerInfo } from '../ISharedWithMeContentInfo';

export module ShareActivityMapper {

  export function map(
    shareActions: IShareAction[],
    sharedVersions: _.Dictionary<_.Dictionary<ISharedVersion>>,
    sharers: _.Dictionary<IUserInfo>,
    deletedSharers: _.Dictionary<IUserInfo>,
  ): ISharedVersionInfo[] {

    return shareActions.map((shareAction: IShareAction): ISharedVersionInfo => {
      const currVersion = sharedVersions[shareAction.contentType][shareAction.contentId];
      const currSharer: ISharerInfo = shareAction.isSharerDeleted ?
        {
          ...deletedSharers[shareAction.sharerId],
          isDeleted: true
        } :
        {
          ...sharers[shareAction.sharerId],
          isDeleted: false
        };

      return {
        id:                         currVersion && currVersion.id,
        contentType:                ContentMapper.mapContentType(shareAction.contentType),
        name:                       currVersion.name,
        message:                    shareAction.message,
        sharedAt:                   MapperHelper.toDate(shareAction.createdAt),
        sharer:                     currSharer,
        url:                        currVersion.url,
        isHidden:                   currVersion.isHidden,
      };
    });
  }
}
